import { render, staticRenderFns } from "./automaticMode.vue?vue&type=template&id=7333c66f&"
import script from "./automaticMode.vue?vue&type=script&lang=ts&"
export * from "./automaticMode.vue?vue&type=script&lang=ts&"
import style0 from "./automaticMode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports